import {observer} from 'mobx-react';
import {t, withDisplay, withState} from 'shared/core';
import {Layout, Panel} from 'shared/components';
import {auth} from 'main/tools';
import {CalendarVisibilityPanel} from 'main/components/visibility_settings';
import {CalendarDirectoryState} from '../state';
import SubNav from 'main/containers/company_settings/SubNav';
import LegacyCalendarList from './LegacyCalendarList';
import SegmentCalendarList from './SegmentCalendarList';
import CalendarSettingsPanel from './CalendarSettingsPanel';

const CalendarDirectoryContainer = observer(({uiState}) => {
  return (
    <Layout>
      <Panel.Stack loose>
        <CalendarSettingsPanel/>
        {auth.user.admin && <CalendarVisibilityPanel uiState={uiState.visibilitySettings}/>}
        <LegacyCalendarList uiState={uiState}/>
        <SegmentCalendarList uiState={uiState}/>
      </Panel.Stack>
    </Layout>
  );
});

export default withDisplay(withState(CalendarDirectoryContainer, CalendarDirectoryState), () => <SubNav title={t('company_settings.subnav.Calendars')}/>);
